export default __webpack_public_path__ + "static/media/cementIndustry.15777d52.jpg";